import moment from 'moment';

/**
 * Utiity function to floor date to hh:MM
 * @param date The source date (moment params accepted)
 * @return the date floored to hh:MM as a Date object
 */
export function floorDate(date: moment.MomentInput) {
  if (!date) {
    return null;
  }

  const floored = moment(date).toDate();
  floored.setSeconds(0);
  floored.setMilliseconds(0);
  return floored;
}
